import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ed99e2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tool_tip_nav" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 3 }

import SimpleCheckbox from '@/components/atoms/SimpleCheckbox'
import { deepCopy } from '@/js/utils/util'
import { computed, ref, watch, withDefaults } from 'vue'
import { useStore } from 'vuex'

type CameraInfoType = {
  showDate: boolean
  showMotionDetectArea: boolean
  showMotionDetectAnalysisInfo: boolean
  showEnterDetectArea: boolean
  showOperationAnalysisArea: boolean
  showVideoSemanticCaption: boolean
}

type CameraInfoNavPositionType = {
  bottom: string
  right: string
}

type PropsType = {
  cameraInfo: CameraInfoType
  position: CameraInfoNavPositionType
  isMultiVideo?: boolean
  liveState?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraInfoNav',
  props: {
    cameraInfo: null,
    position: null,
    isMultiVideo: { type: Boolean, default: false },
    liveState: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { cameraInfo: CameraInfoType, position: CameraInfoNavPositionType, isMultiVideo: boolean, liveState: boolean };

const store = useStore()



const cameraInfoState = ref<CameraInfoType>(deepCopy(props.cameraInfo))

const cameraDetail = computed(() => store.getters['detail/cameraDetail'])
const isTLT = computed(() => store.getters['app/isTLT'])
const showVideoSemanticCaptionOption = computed(
  () => cameraDetail.value.use_video_semantic_search && !props.liveState
)

const setCameraInfo = (cameraInfo: CameraInfoType) => {
  store.commit('detail/setCameraInfo', cameraInfo)
}

watch(
  cameraInfoState,
  (v) => {
    //   TODO handler check必要
    setCameraInfo({
      showDate: v.showDate,
      showMotionDetectArea: v.showMotionDetectArea,
      showMotionDetectAnalysisInfo: v.showMotionDetectAnalysisInfo,
      showEnterDetectArea: v.showEnterDetectArea,
      showOperationAnalysisArea: v.showOperationAnalysisArea,
      showVideoSemanticCaption: v.showVideoSemanticCaption,
    })
  },
  {
    deep: true,
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "player_tool_tip",
    onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('mouseleave'))),
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
    style: _normalizeStyle(__props.position)
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("label", null, [
        _createElementVNode("span", null, [
          _createVNode(_unref(SimpleCheckbox), {
            modelValue: cameraInfoState.value.showDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cameraInfoState.value.showDate) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('player_controller.datetime')), 1)
      ]),
      (!__props.isMultiVideo)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(cameraDetail).use_motion)
              ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
                  _createElementVNode("span", null, [
                    _createVNode(_unref(SimpleCheckbox), {
                      modelValue: cameraInfoState.value.showMotionDetectArea,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cameraInfoState.value.showMotionDetectArea) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('player_controller.motion_detection_area')), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(cameraDetail).use_motion)
              ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
                  _createElementVNode("span", null, [
                    _createVNode(_unref(SimpleCheckbox), {
                      modelValue: cameraInfoState.value.showMotionDetectAnalysisInfo,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cameraInfoState.value.showMotionDetectAnalysisInfo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('player_controller.motion_detection_analysis')), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(isTLT))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_unref(cameraDetail).use_enter_alert)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                        _createElementVNode("span", null, [
                          _createVNode(_unref(SimpleCheckbox), {
                            modelValue: cameraInfoState.value.showEnterDetectArea,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cameraInfoState.value.showEnterDetectArea) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('player_controller.enter_alert_area')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(cameraDetail).use_operation_analysis)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
                        _createElementVNode("span", null, [
                          _createVNode(_unref(SimpleCheckbox), {
                            modelValue: cameraInfoState.value.showOperationAnalysisArea,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cameraInfoState.value.showOperationAnalysisArea) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('player_controller.operation_analysis_area')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_unref(showVideoSemanticCaptionOption))
              ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createElementVNode("span", null, [
                    _createVNode(_unref(SimpleCheckbox), {
                      modelValue: cameraInfoState.value.showVideoSemanticCaption,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cameraInfoState.value.showVideoSemanticCaption) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('player_controller.video_semantic_caption_display')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 36))
}
}

})